<template>
  <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" custom-class="successDialog" :append-to-body="true" width="450px">
    <div class="tipsContent">
      <i class="el-icon-circle-check succIcon"></i>
      <p class="title">{{ title }}</p>
      <p class="text">您好！该时间段已经有人预约了。</p>
      <p class="text">请更改你的预约时间。</p>
      <el-button type="primary" round @click="updateAppointment()">更改预约时间</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      title: "预约失败",
    };
  },
  methods: {
    init(orderId, orderType) {
      this.orderId = orderId;
      this.orderType = orderType;
      this.dialogVisible = true;
    },
    updateAppointment() {
      this.dialogVisible = false;
      this.$emit("showTimePanel");
    },
  },
};
</script>

<style lang="scss" scoped></style>
